export const nav = 1;
import ServiceBus from "servicestack/service-bus";

export const getInvStates = ({
  mode = "inv",
  menu = "retailer",
  base = menu ? `${menu}.${mode}` : mode,
  nav = 1,
  title = "Invoices",
  icon = "usd",
  url = `/${mode}s`, //?customerId&retailerId
  breadcrumbs = false,
  pageHeader = false,
  retailerId,
  customerId = retailerId,
} = {}) => {
  const states = {
    [base]: {
      nav,
      menu, // <ui-view/>
      breadcrumbs,
      pageHeader,
      icon,
      title,
      url, // + "?uploaded&mode",
      params: {},
      rerouteTo: `${base}.list`,
      resolve: {
        retailerId: ($stateParams) =>
          $stateParams.retailerId || $stateParams.customerId || customerId,
        customerId: ($stateParams) =>
          $stateParams.customerId || $stateParams.retailerId || customerId,
        mode: () => mode,
      },
      templateProvider: ($stateParams) => `<inv-container
        customer="$ctrl.customer"
        enable-query-string="true"
        detail-route="^.detail"
        hide-header="true"
        mode="${mode}"
        customer-id="'${
          $stateParams.retailerId || $stateParams.customerId || customerId
        }'" />`,
    },
    [`${base}.list`]: {
      menu: base,
      nav: false,
      breadcrumbs: false,
      pageHeader: false,
      icon: "usd",
      title: "List",
      resolve: {},
      templateProvider: ($stateParams) => `<inv-list  />`,
    },
    [`${base}.detail`]: {
      menu: base,
      nav: false,
      url: "/{invoiceId:[^/]+}?openedit",
      title: "Detail",
      breadcrumbs: false,
      pageHeader: false,
      resolve: {
        mode: () => mode,
        invoiceId: ($stateParams) => $stateParams.invoiceId,
      },
      templateProvider: ($stateParams) => `<inv-details 
            customer-id="'${
              $stateParams.retailerId || $stateParams.customerId || customerId
            }'"
            invoice-id="${$stateParams.invoiceId}" 
            openedit="${$stateParams.openedit}" 
            mode="${mode}"/>`,
    },
  };

  return states;
};

export const getStates = (menu, mode = "inv", other) => {
  const base = menu ? `${menu}.${mode}` : mode;
  return {
    [base]: {
      nav,
      menu, // <ui-view/>
      breadcrumbs: false,
      pageHeader: false,
      icon: "usd",
      title: "Invoices",
      url: "/" + mode + "?retailerId", // + "?uploaded&mode",
      params: {},
      rerouteTo: `${base}.list`,
      resolve: {
        mode: () => mode,
        retailerId: ($stateParams) => $stateParams.retailerId,
      },
      templateProvider: ($stateParams) => `<inv-container 
      retailer-id="'${$stateParams.retailerId}'"  
      mode="${mode}"   />`,
      ...other,
    },
    [`${base}.list`]: {
      menu: base,
      nav: false,
      breadcrumbs: false,
      pageHeader: false,
      icon: "usd",
      title: "List",
      resolve: {},
      templateProvider: ($stateParams) => `<inv-list  mode="${mode}"  />`,
    },
    [`${base}.detail`]: {
      menu: base,
      nav: false,
      url: "/{invoiceId:[^/]+}",
      title: "Detail",
      breadcrumbs: false,
      pageHeader: false,
      params: {},
      resolve: {
        mode: () => mode,
        invoiceId: ($window, $stateParams) => $stateParams.invoiceId,
      },
      templateProvider: ($stateParams) => `<inv-details mode="${mode}" invoice-id="${$stateParams.invoiceId}"/>`,
    },
    [`${base}.request-credit`]: {
      menu: base,
      nav: false,
      url: "/{invoiceId:[^/]+}?status",
      title: "Detail",
      onEnter($state, $stateParams) {
        ServiceBus.send("CreateCreditMemoRequest.json?jsconfig=ua,uaa", {
          invoiceId: $stateParams.invoiceId,
          status: $stateParams.status || "Open",
        }).then(({ data }) => {
          console.debug("CreateCreditMemoRequest", data);
          $state.go("^.^.credit-request.detail", { creditRequestId: data.id });
        }, (res) => {
          console.debug("CreateCreditMemoRequest", res);
          if (res.data.responseStatus.errorCode == "CreditMemoRequestExists") {
            $state.go("^.^.credit-request.detail", { creditRequestId: res.data.responseStatus.errors[0].fieldName });
          }
        });
      },
    },
  };
};

export default getStates();
